import React from 'react'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'

export function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="localhost:3000">
        Accounting Hub
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  )
}